<template>
  <div class="flex justify-start items-center body-font">
    <router-link
      v-if="logoLabel || logoIcon"
      class="flex items-center text-main font-black text-2xl main-font gap-2"
      to="/profile"
    >
      <img v-if="logoIcon" :src="logoIcon" alt="logo" class="h-8 w-auto" />
      <span v-if="logoLabel">{{ logoLabel }}</span>
    </router-link>
    <router-link active-class="active-tab interactive-text" class="ml-12 highlight inactive-tab" to="/profile">
      {{ $t("navbar.profile") }}
    </router-link>
    <router-link
      :to="{ name: 'Sessions' }"
      active-class="active-tab interactive-text"
      class="ml-12 highlight inactive-tab"
    >
      {{ $t("navbar.sessions") }}
    </router-link>
    <router-link
      :to="{ name: 'Availability' }"
      active-class="active-tab interactive-text "
      class="ml-12 highlight inactive-tab"
    >
      {{ $t("navbar.availability") }}
    </router-link>
    <router-link
      :to="{ name: 'SessionsLog' }"
      active-class="active-tab interactive-text"
      class="ml-12 highlight inactive-tab"
    >
      {{ $t("navbar.sessions.log") }}
    </router-link>
    <div v-if="validateVoucherLink">
      <primary-button class="ml-12" @click="openValidateVoucher">
        {{ $t("validate_voucher.button") }}
      </primary-button>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/ui-kit/buttons/PrimaryButton.vue";

export default {
  name: "NavBar",
  components: { PrimaryButton },
  data() {
    return {
      logoLabel: process.env.VUE_APP_LOGO_LABEL || "",
      logoIcon: process.env.VUE_APP_LOGO_ICON || "",
      validateVoucherLink: process.env.VUE_APP_VALIDATE_VOUCHER_LINK_VALUE || null
    };
  },
  methods: {
    openValidateVoucher() {
      window.open(this.validateVoucherLink, "_blank");
    }
  }
};
</script>

<style scoped></style>
